import React from "react"

import { StaticImage } from "gatsby-plugin-image"

const Testimonial = () => {
  return (
    <div className="container-lg mt-8 sm:mt-10">
      <div className="w-[calc(100%+32px)] -mx-4 lg:mx-0 lg:w-full py-16 px-4 md:px-[163px] bg-neutral-2 lg:rounded-2xl flex flex-col items-center gap-8">
        <StaticImage
          src="../../../images/testimonials/matt-hq.png"
          className="rounded-full"
          alt="Matt Mullenweg avatar"
          layout="fixed"
          width={80}
          height={80}
          quality={100}
        />
        <p className="text-jar-7 text-center italic">
          ... I joined SitePoint to learn more about web stuff and their
          PHP/MySQL tutorial was probably the first I used.
        </p>
        <div className="flex flex-col gap-1.5 text-center">
          <span className="text-jar-4 font-medium text-neutral-12">
            Matt Mullenweg
          </span>
          <p className="text-jar-3 text-neutral-11">
            Creator of WordPress, CEO of Automattic
          </p>
        </div>
      </div>
    </div>
  )
}

export default Testimonial
